import { LoginFormContent } from '@fukuri-admins/ui/common';
import React, { ComponentProps } from 'react';
import styles from './styles.module.scss';

type LoginFormContentProps = ComponentProps<typeof LoginFormContent>;

type Props = {
  title: LoginFormContentProps['title'];
  onSubmit: LoginFormContentProps['onSubmit'];
  errorMessage: LoginFormContentProps['errorMessage'];
  buttonDisabled: LoginFormContentProps['buttonDisabled'];
  emailPlaceholder?: LoginFormContentProps['emailPlaceholder'];
};

export const LoginModalPresentation: React.FC<Props> = ({
  title,
  onSubmit,
  errorMessage,
  buttonDisabled,
  emailPlaceholder,
}) => (
  <div className={styles.LoginModal}>
    <LoginFormContent
      title={title}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      buttonDisabled={buttonDisabled}
      emailPlaceholder={emailPlaceholder}
    />
  </div>
);
